import type { CSSObject } from '@emotion/react'
import { css } from '@emotion/react'

export const downloadText = css({
  marginInlineStart: 5,
  paddingBlockStart: 1,
})

export const link: CSSObject = {
  display: 'flex',
  lineHeight: 'initial', // help center icon vertically
}
